import { frontendURL } from '../../../helper/URLHelper';
import CopilotPage from './CopilotPage.vue';

const meta = {
  permissions: ['administrator', 'agent'],
};

export const routes = [
  {
    path: frontendURL('accounts/:accountId/copilot'),
    name: 'copilot_home',
    component: CopilotPage,
    meta,
  },
];
